import {
  Button,
  Center,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { InfoCircle } from "../icons/icons";

import { useState } from "react";
import CustomTextarea from "../input/CustomTextarea";

import InvalidInput from "../input/InvalidInput";

const ReportErrorModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (s: string) => void;
  isLoading: boolean;
}) => {
  const [detail, setDetail] = useState("");

  const [error, setError] = useState(false);

  const validateData = () => {
    if (detail === "") {
      setError(true);
      return false;
    }
    setError(false);
    return true;
  };

  const onSend = () => {
    onConfirm(detail);
    setDetail("");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />

      <ModalContent mx="5px">
        <ModalCloseButton />

        <ModalBody p="0 0 20px 0">
          <Center>
            <Icon
              w="50px"
              h="50px"
              viewBox="0 0 50 50"
              fill="none"
              color="#FFCC00"
            >
              <InfoCircle />
            </Icon>
          </Center>
          <Center>
            <Text
              variant="title"
              fontSize="lg"
              fontWeight="500"
              mb="20px"
              mt="10px"
            >
              Have you found a problem?
            </Text>
          </Center>
          <Text
            variant="title"
            fontSize="lg"
            lineHeight="19px"
            mt="25px"
            mb="10px"
          >
            Tell us more
          </Text>
          <CustomTextarea
            value={detail}
            onChange={(v) => setDetail(v)}
            placeholder="Please describe the problem you have found..."
          />
          <InvalidInput isError={error} override="Field can't be empty" />
          <Flex mt="20px" mb="10px" gap="10px">
            <Button variant="light" w="100%" onClick={onClose}>
              Close
            </Button>
            <Button
              variant="heavy"
              w="100%"
              isLoading={isLoading}
              onClick={() => (validateData() ? onSend() : {})}
            >
              Send
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReportErrorModal;
